/*
  ============================================================
  cart-gifts.js — Régua de brindes por valor (escolha 1 tier)
  ------------------------------------------------------------
  Mecânica de "adição invisível":
  - Selecionar um brinde adiciona o(s) produto(s) ao carrinho REAL
    via AJAX interno, mas a LINHA do brinde fica OCULTA na lista do
    drawer (a própria seção de brindes já mostra que ele está no
    carrinho). Sem refresh, sem piscar.
  - IDENTIDADE do brinde: a linha de brinde carrega a propriedade de
    linha "Brinde" (VISÍVEL). É ela que distingue o brinde de uma COMPRA
    paga do mesmo cadastro — por isso o mesmo produto pode ser vendido
    avulso E ofertado como brinde. A linha paga (sem a propriedade) conta
    para o mínimo e é cobrada. A propriedade é visível porque o checkout
    mescla linhas da mesma variante sem diferença visível — com "_brinde"
    (oculta) o brinde sumia no checkout.
  - O contador do cabeçalho mostra o total REAL (compras + brindes).
  - Quem zera o preço no checkout é o desconto automático BXGY da
    Shopify (o subtotal do carrinho já reflete o desconto quando a
    Shopify o aplica no carrinho).
  - RECONCILIAÇÃO (gancho de fetch nas respostas /cart*.js que o
    tema lê): remove brindes fora do tier escolhido, força qtd 1,
    completa tier multi-produto e remove tudo se o valor cair
    abaixo da faixa.
  - ELEGIBILIDADE: o mínimo conta TODAS as linhas pagas (a coleção
    do desconto no admin abrange o catálogo: preço > R$ 1,00);
    apenas as linhas de brinde ficam de fora.
  - SEM ESTOQUE: tier é ocultado se QUALQUER produto dele estiver
    indisponível.
  Regras de negócio: definidas no snippet cart-gifts.liquid.
  ============================================================
*/
(function () {
  'use strict';
  if (window.__cartGiftsLoaded) return;
  window.__cartGiftsLoaded = true;

  var LOG = '[Brindes]';
  var HDR = 'x-cart-gifts-internal';
  // A LINHA de brinde é marcada por esta propriedade de linha. É ela — não a
  // variante — que distingue o brinde de uma compra paga do MESMO produto:
  // assim o mesmo cadastro pode ser vendido normalmente E ofertado como
  // brinde. A propriedade é VISÍVEL (sem "_" inicial) de propósito: o
  // checkout agrupa as linhas por variante + atributos VISÍVEIS, então uma
  // propriedade oculta ("_brinde") faria o checkout MESCLAR a linha de
  // brinde com a linha paga da mesma variante (o brinde "sumia" no
  // checkout, ficava só a venda). Visível, a linha do brinde fica separada
  // e ainda rotula o item como cortesia (útil na separação do pedido).
  var GIFT_PROP = 'Brinde';
  var GIFT_PROP_VAL = 'Cortesia';

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  var esc = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="11" fill="#fff"/><polyline points="7 12.5 10.5 16 17 8.5" fill="none" stroke="#1fa463" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
  // Mão de toque/click (vetorização em contornos do hand_click.png):
  // raios de clique + indicador estendido, nós dos dedos e polegar curvado.
  var ICON_HAND = '<svg viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M104 16v44M40 40l30 30M14 104h44M40 168l30-30M168 40l-30 30"/>' +
    '<path d="M82 118A28 28 0 1 1 137 84Q190 160 236 236A36 36 0 1 1 300 212A36 36 0 1 1 366 206A33 33 0 1 1 428 228C452 262 476 326 498 396C446 428 390 462 332 494C282 452 226 416 172 388C146 374 134 350 138 330C142 308 166 304 178 318C186 328 188 338 184 346L198 332C160 270 115 180 82 118Z"/>' +
    '</svg>';

  // ---------- Gancho global de fetch (instalado uma única vez) ----------
  var nativeFetch = window.fetch.bind(window);
  var reconcileHook = null;

  function pathOf(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return url.split('?')[0];
  }
  function isInternal(init) {
    return !!(init && init.headers && (init.headers[HDR] || (init.headers.get && init.headers.get(HDR))));
  }

  window.fetch = async function (input, init) {
    var res = await nativeFetch(input, init);
    try {
      if (!isInternal(init) && reconcileHook) {
        var p = pathOf(input);
        if (/\/cart(\.js|\/change\.js|\/update\.js|\/clear\.js)$/.test(p)) {
          var cart = await res.clone().json();
          if (cart && Array.isArray(cart.items)) {
            var fixed = await reconcileHook(cart);
            if (fixed) {
              return new Response(JSON.stringify(fixed), {
                status: 200,
                headers: { 'Content-Type': 'application/json' },
              });
            }
          }
        }
      }
    } catch (e) { console.warn(LOG, 'gancho de fetch falhou (seguindo normal):', e); }
    return res;
  };

  var internalGet = function (url) { return nativeFetch(url, { headers: { 'x-cart-gifts-internal': '1' } }); };
  var internalPost = function (url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-cart-gifts-internal': '1' },
      body: JSON.stringify(body),
    });
  };
  // Adiciona o brinde como uma LINHA própria, carregando a propriedade de
  // brinde — separada da linha paga da mesma variante (o /cart/add.js cria
  // linha nova quando as properties diferem). update.js NÃO cria linha com
  // propriedade, por isso a adição é sempre por aqui. O desconto automático
  // BXGY da Shopify zera essa linha no carrinho/checkout.
  var internalAdd = function (variantId) {
    var props = {};
    props[GIFT_PROP] = GIFT_PROP_VAL;
    return internalPost('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: props }] });
  };
  // O cart-extras (cupom/frete/resumo) tem gancho no window.fetch, mas o
  // nosso nativeFetch foi capturado ANTES dele carregar — as chamadas
  // internas daqui passam por fora e ele ficaria cego às operações de
  // brinde. Entregamos o carrinho final para ele re-sincronizar o resumo,
  // o riscado do cupom por linha e a validade da cotação de frete.
  function syncExtras(cart) {
    try { if (cart && window.__cartExtrasSync) window.__cartExtrasSync(cart); } catch (e) { /* segue */ }
  }

  // ---------- Custom element ----------
  class CartGifts extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try {
        var raw = JSON.parse(this.querySelector('.cart-gifts__data').textContent);
        // Tier entra na régua só se TODOS os produtos existem e têm estoque.
        this.config = raw
          .filter(function (t) {
            return (t.products || []).length && t.products.every(function (p) { return p.exists && p.available; });
          })
          .sort(function (a, b) { return a.threshold - b.threshold; });
      } catch (e) { console.error(LOG, 'config inválida:', e); return; }

      this.root = this.querySelector('[data-cart-gifts-root]');
      this.chosenTier = null;
      this.userPicked = false;
      this.sizeChoice = {};
      this._failedAdds = {};

      this.giftVariants = new Set();
      var self = this;
      this.config.forEach(function (tier) {
        tier.products.forEach(function (p) {
          (p.variants || []).forEach(function (v) { self.giftVariants.add(v.id); });
        });
      });

      if (!this.config.length) { this.hidden = true; return; }

      reconcileHook = function (cart) { return self.reconcile(cart); };
      console.info(LOG, 'carregado — níveis:', this.config.length);
      this.relocate();
      this.observeItemsList();
      this.setupDragScroll();
      this.refresh();
    }

    // Arrastar-para-rolar com o mouse (desktop) no trilho de brindes.
    // Delegado no próprio <cart-gifts> para sobreviver aos re-renders;
    // um arrasto real (>4px) suprime o clique para não selecionar brinde
    // sem querer.
    setupDragScroll() {
      var self = this;
      this._drag = null;
      this._suppressClick = false;
      this.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        var row = e.target.closest('.cart-gifts__scroller');
        if (!row || e.target.closest('select')) return;
        self._drag = { row: row, startX: e.pageX, startScroll: row.scrollLeft, moved: false };
        row.classList.add('is-dragging');
        e.preventDefault(); // sem seleção de texto/ghost de imagem
      });
      document.addEventListener('mousemove', function (e) {
        var d = self._drag;
        if (!d) return;
        var dx = e.pageX - d.startX;
        if (Math.abs(dx) > 4) d.moved = true;
        d.row.scrollLeft = d.startScroll - dx;
      });
      document.addEventListener('mouseup', function () {
        var d = self._drag;
        if (!d) return;
        d.row.classList.remove('is-dragging');
        self._suppressClick = d.moved;
        self._drag = null;
        if (self._suppressClick) setTimeout(function () { self._suppressClick = false; }, 0);
      });
      // captura: roda antes dos handlers dos cards/goals
      this.addEventListener('click', function (e) {
        if (self._suppressClick) { e.stopPropagation(); e.preventDefault(); }
      }, true);
    }

    relocate() {
      try {
        var items = document.querySelector('cart-component .cart-items');
        if (items && items.firstChild !== this) items.insertBefore(this, items.firstChild);
      } catch (e) { console.warn(LOG, 'relocate falhou:', e); }
    }

    // Brinde = variante de um tier E com a propriedade _brinde. A linha
    // PAGA da mesma variante (sem a propriedade) NÃO é brinde: conta para o
    // mínimo da régua e é vendida/cobrada normalmente.
    isGift(item) {
      return this.giftVariants.has(item.variant_id)
        && !!(item.properties && item.properties[GIFT_PROP] != null);
    }

    resolveVariant(tierIdx, p) {
      if (p.needsSize) {
        var chosen = this.sizeChoice[tierIdx + ':' + p.handle];
        return chosen || null;
      }
      var avail = (p.variants || []).find(function (v) { return v.available; });
      return (avail || (p.variants || [])[0] || {}).id || null;
    }
    resolveTier(tierIdx) {
      var tier = this.config[tierIdx];
      if (!tier) return null;
      var out = [];
      for (var i = 0; i < tier.products.length; i++) {
        var v = this.resolveVariant(tierIdx, tier.products[i]);
        if (!v) return null;
        out.push(v);
      }
      return out;
    }
    variantsOfTier(tierIdx) {
      var s = new Set();
      var tier = this.config[tierIdx];
      if (tier) tier.products.forEach(function (p) { (p.variants || []).forEach(function (v) { s.add(v.id); }); });
      return s;
    }

    // Mínimo da régua: soma de todas as linhas pagas (não-brinde). A coleção
    // do desconto no admin abrange o catálogo (preço > R$ 1,00), então não há
    // filtro de elegibilidade por produto.
    eligibleTotal(cart) {
      var self = this;
      return cart.items.reduce(function (s, i) {
        return s + (self.isGift(i) ? 0 : i.final_line_price);
      }, 0);
    }

    tierEligible(idx, paid) {
      return idx != null && this.config[idx] && paid >= this.config[idx].threshold;
    }

    async refresh() {
      try {
        var cart = await internalGet('/cart.js').then(function (r) { return r.json(); });
        var fixed = await this.reconcile(cart);
        this.render(fixed || cart);
      } catch (e) { console.error(LOG, 'refresh falhou:', e); }
    }

    // Limpeza/convergência (chamada pelo gancho de fetch e pelo refresh).
    async reconcile(cart) {
      if (this._reconciling) return null;
      this._reconciling = true;
      try {
        var self = this;
        var paid = this.eligibleTotal(cart);
        var gifts = cart.items.filter(function (i) { return self.isGift(i); });

        var keep = this.tierEligible(this.chosenTier, paid) ? this.chosenTier : null;
        if (keep == null) {
          this.userPicked = false;
          for (var t = this.config.length - 1; t >= 0; t--) {
            if (!this.tierEligible(t, paid)) continue;
            var complete = this.config[t].products.every(function (p) {
              return (p.variants || []).some(function (v) {
                return gifts.some(function (g) { return g.variant_id === v.id; });
              });
            });
            if (complete) { keep = t; this.userPicked = true; break; }
          }
        }
        this.chosenTier = keep;

        // conjunto-alvo (tamanhos já no carrinho valem como escolha pós-reload)
        var target = [];
        var targetSet = new Set();
        if (keep != null) {
          var tierAll = this.variantsOfTier(keep);
          gifts.forEach(function (g) {
            if (!tierAll.has(g.variant_id)) return;
            self.config[keep].products.forEach(function (p) {
              if (p.needsSize && (p.variants || []).some(function (v) { return v.id === g.variant_id; })) {
                var key = keep + ':' + p.handle;
                if (!self.sizeChoice[key]) self.sizeChoice[key] = g.variant_id;
              }
            });
          });
          target = this.resolveTier(keep) || [];
          targetSet = new Set(target);
        }

        // remoções e correção de quantidade: SEMPRE pela CHAVE da linha de
        // brinde (a linha paga da mesma variante nunca é tocada).
        var updates = {};
        gifts.forEach(function (g) {
          if (!targetSet.has(g.variant_id)) updates[g.key] = 0;
          else if (g.quantity !== 1) updates[g.key] = 1;
        });

        // adições: variantes do tier que ainda não têm LINHA de brinde.
        // Entram via add.js (com a propriedade _brinde), nunca durante uma
        // seleção em andamento (evita a corrida com o chooseGift).
        var present = {};
        gifts.forEach(function (g) { present[g.variant_id] = true; });
        var missing = (this.userPicked && keep != null && !this._choosing)
          ? target.filter(function (v) { return !present[v] && !self._failedAdds[v]; })
          : [];

        if (Object.keys(updates).length === 0 && missing.length === 0) { this.render(cart); return null; }

        if (Object.keys(updates).length) await internalPost('/cart/update.js', { updates: updates });
        for (var mi = 0; mi < missing.length; mi++) {
          var addRes = await internalAdd(missing[mi]);
          if (!addRes.ok) self._failedAdds[missing[mi]] = true;
        }
        var newCart = await internalGet('/cart.js').then(function (r) { return r.json(); });
        this.render(newCart);
        syncExtras(newCart);
        return newCart;
      } catch (e) { console.error(LOG, 'reconcile falhou:', e); return null; }
      finally { this._reconciling = false; }
    }

    // Seleciona/alterna o tier — tudo via API interna ("adição invisível").
    // Toggle: clicar no já selecionado desmarca e remove (cliente decide
    // não levar o brinde).
    async chooseGift(idx) {
      var self = this;
      var tier = this.config[idx];
      if (!tier || this._choosing) return;

      var missingSize = this.chosenTier !== idx && tier.products.some(function (p) {
        return p.needsSize && !self.sizeChoice[idx + ':' + p.handle];
      });
      if (missingSize) { this.flashSizePrompt(idx); return; }

      this._choosing = true;
      this.setCardBusy(idx, true); // spinner enquanto o carrinho atualiza
      try {
        var deselect = this.chosenTier === idx;
        this.chosenTier = deselect ? null : idx;
        this.userPicked = !deselect;
        // feedback imediato só ao SELECIONAR; ao desmarcar, o card segue
        // "selecionado" durante o loading e limpa no render final.
        // Ao selecionar, o trilho desliza até o card clicado virar o
        // "primeiro" à esquerda (só brindes liberados chegam aqui).
        if (!deselect) {
          this.applySelectedUI(this.chosenTier);
          this.scrollToCard(idx);
        }

        var cart = await internalGet('/cart.js').then(function (r) { return r.json(); });
        var targetSet = new Set(deselect ? [] : (this.resolveTier(idx) || []));

        // remove os brindes fora do alvo, pela CHAVE da linha (sem encostar
        // na linha paga da mesma variante)
        var updates = {};
        var present = {};
        cart.items.forEach(function (i) {
          if (!self.isGift(i)) return;
          present[i.variant_id] = true;
          if (!targetSet.has(i.variant_id)) updates[i.key] = 0;
        });
        if (Object.keys(updates).length) await internalPost('/cart/update.js', { updates: updates });

        // adiciona os brindes do alvo que ainda não têm linha (add.js + _brinde)
        var added = [];
        var addFailed = false;
        var toAdd = [];
        targetSet.forEach(function (v) { if (!present[v] && !self._failedAdds[v]) toAdd.push(v); });
        for (var ti = 0; ti < toAdd.length; ti++) {
          var addRes = await internalAdd(toAdd[ti]);
          if (addRes.ok) added.push(toAdd[ti]);
          else { self._failedAdds[toAdd[ti]] = true; addFailed = true; }
        }
        if (addFailed && !added.length && !deselect) {
          this.chosenTier = null;
          this.userPicked = false;
        }

        var newCart = await internalGet('/cart.js').then(function (r) { return r.json(); });
        this.updateHeaderCount(newCart);
        this.render(newCart);
        syncExtras(newCart);
      } catch (e) { console.error(LOG, 'seleção falhou:', e); }
      finally { this._choosing = false; this.setCardBusy(idx, false); }
    }

    // Liga/desliga o spinner de um card (o render() recria o DOM, então o
    // "desligar" só é necessário em falhas que não re-renderizam).
    setCardBusy(idx, busy) {
      try {
        var card = this.root.querySelector('[data-card="' + idx + '"]');
        if (card) card.classList.toggle('is-busy', !!busy);
      } catch (e) { /* segue */ }
    }

    // Troca de tamanho com o tier já selecionado: re-sincroniza via API.
    async swapSize(tierIdx) {
      if (this.chosenTier !== tierIdx) return;
      var self = this;
      var target = this.resolveTier(tierIdx);
      if (!target) return;
      this.setCardBusy(tierIdx, true);
      try {
        var cart = await internalGet('/cart.js').then(function (r) { return r.json(); });
        var targetSet = new Set(target);
        // troca de tamanho: zera as linhas de brinde fora do alvo (por chave)
        // e adiciona o tamanho escolhido que ainda não estiver no carrinho
        var updates = {};
        var present = {};
        cart.items.forEach(function (i) {
          if (!self.isGift(i)) return;
          present[i.variant_id] = true;
          if (!targetSet.has(i.variant_id)) updates[i.key] = 0;
        });
        if (Object.keys(updates).length) await internalPost('/cart/update.js', { updates: updates });
        for (var si = 0; si < target.length; si++) {
          if (!present[target[si]]) await internalAdd(target[si]);
        }
        var newCart = await internalGet('/cart.js').then(function (r) { return r.json(); });
        this.updateHeaderCount(newCart);
        this.render(newCart);
        syncExtras(newCart);
      } catch (e) { console.error(LOG, 'troca de tamanho falhou:', e); }
      finally { this.setCardBusy(tierIdx, false); }
    }

    // Contador do cabeçalho = total REAL (compras + brindes selecionados).
    updateHeaderCount(cart) {
      try {
        var n = cart.item_count;
        document.querySelectorAll('[data-items-count]').forEach(function (el) {
          el.textContent = '(' + n + (n === 1 ? ' item' : ' itens') + ')';
        });
      } catch (e) { /* segue */ }
    }

    // Linhas de brinde ficam OCULTAS na lista (a seção de brindes já
    // representa o item no carrinho). Casamos pela CHAVE exata da linha de
    // brinde ("<variantId>:<hash>") lida do carrinho — assim a linha PAGA
    // da mesma variante (chave diferente) continua visível e vendável.
    decorateGiftLines(cart) {
      var self = this;
      var c = cart || this._lastCart;
      var giftKeys = {};
      if (c && c.items) c.items.forEach(function (i) { if (self.isGift(i)) giftKeys[i.key] = true; });
      var apply = function () {
        document.querySelectorAll('.cart-drawer cart-item[data-key]').forEach(function (el) {
          el.classList.toggle('cart-item--gift-line', !!giftKeys[el.getAttribute('data-key')]);
        });
      };
      apply();
      requestAnimationFrame(apply);
    }

    observeItemsList() {
      var self = this;
      var list = document.querySelector('cart-component cart-items-list')
        || document.querySelector('cart-component .cart-items--list');
      if (!list || typeof MutationObserver === 'undefined') return;
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          self.decorateGiftLines();
        }, 30);
      }).observe(list, { childList: true, subtree: true });
    }

    applySelectedUI(tierIdx) {
      if (!this.root) return;
      this.root.querySelectorAll('[data-card]').forEach(function (card) {
        var sel = parseInt(card.getAttribute('data-card'), 10) === tierIdx;
        card.classList.toggle('is-selected', sel);
      });
      this.root.querySelectorAll('[data-step]').forEach(function (st) {
        st.classList.toggle('is-selected', parseInt(st.getAttribute('data-step'), 10) === tierIdx);
      });
    }

    // ---------- UI ----------
    render(cart) {
      if (!this.root) return;
      var self = this;
      this._lastCart = cart;

      var paid = this.eligibleTotal(cart);

      var states = this.config.map(function (tier, i) {
        return { tier: tier, idx: i, unlocked: paid >= tier.threshold, selected: self.chosenTier === i };
      });
      var unlockedCount = states.filter(function (s) { return s.unlocked; }).length;
      var next = states.find(function (s) { return !s.unlocked; }) || null;

      // ---- régua v2: trilho e cards rolam JUNTOS no mesmo scroller; cada
      // goal fica exatamente no centro do card do seu brinde, com um
      // conector vertical suave ligando o goal ao card abaixo.
      var CARD_W = 192; // largura do card (css)
      var GAP = 8;      // gap entre cards (css)
      var PITCH = CARD_W + GAP;
      var n = this.config.length;
      var innerW = n * CARD_W + (n - 1) * GAP;

      // posição (px) do centro de cada card / goal
      var goalX = function (i) { return i * PITCH + CARD_W / 2; };

      // preenchimento: linear por trechos entre os goals
      var fillPx = 0;
      {
        var prevX = 0;
        var prevTh = 0;
        for (var i = 0; i < n; i++) {
          var th = this.config[i].threshold;
          var x = goalX(i);
          if (paid >= th) { fillPx = x; prevX = x; prevTh = th; continue; }
          var frac = Math.max(0, (paid - prevTh) / (th - prevTh));
          fillPx = prevX + frac * (x - prevX);
          break;
        }
        if (n && paid >= this.config[n - 1].threshold) fillPx = innerW;
      }
      this._fillPx = fillPx;

      var stepsHtml = states.map(function (s) {
        var cls = 'cart-gifts__step' + (s.unlocked ? ' is-unlocked' : ' is-locked') + (s.selected ? ' is-selected' : '');
        return '<button type="button" class="' + cls + '" data-step="' + s.idx + '" style="left:' + goalX(s.idx) + 'px">' +
          '<span class="cart-gifts__step-node">' + (s.unlocked ? ICON_CHECK : ICON_LOCK) + '</span>' +
          '<span class="cart-gifts__step-value">' + money(s.tier.threshold) + '</span>' +
          '<span class="cart-gifts__step-link"></span>' +
        '</button>';
      }).join('');

      var nextIdx = next ? next.idx : -1;
      var cardsHtml = states.map(function (s) {
        return self.cardHtml(s, s.idx === nextIdx);
      }).join('');

      var scrollerHtml =
        '<div class="cart-gifts__scroller">' +
          '<div class="cart-gifts__v2" style="width:' + innerW + 'px">' +
            '<div class="cart-gifts__lane">' +
              '<div class="cart-gifts__track"><span class="cart-gifts__fill" style="width:' + fillPx + 'px"></span></div>' +
              stepsHtml +
            '</div>' +
            '<div class="cart-gifts__cards">' + cardsHtml + '</div>' +
          '</div>' +
        '</div>';

      // ---- subtítulo ----
      var subtitle = next
        ? 'Adicione mais <strong>' + money(next.tier.threshold - paid) + '</strong> para liberar o próximo brinde'
        : 'Você desbloqueou todos os brindes — escolha o seu';

      // preserva a rolagem do scroller (régua + cards) entre re-renders
      var prevRow = this.root.querySelector('.cart-gifts__scroller');
      var prevScroll = prevRow ? prevRow.scrollLeft : null;

      this.root.innerHTML =
        '<div class="cart-gifts__header">' +
          '<div class="cart-gifts__htext">' +
            '<div class="cart-gifts__title">Desbloqueie brindes e escolha o seu</div>' +
            '<div class="cart-gifts__subtitle">' + subtitle + '</div>' +
          '</div>' +
        '</div>' +
        scrollerHtml;

      this.hidden = false;
      {
        var row = this.root.querySelector('.cart-gifts__scroller');
        if (row) {
          if (this._scrollTarget != null) {
            // finaliza o deslize da seleção (caso o render tenha
            // interrompido a animação no meio)
            row.scrollLeft = Math.max(0, Math.min(this._scrollTarget, row.scrollWidth - row.clientWidth));
            this._scrollTarget = null;
          } else if (prevScroll != null) {
            row.scrollLeft = prevScroll;
          }
        }
      }
      this.bindEvents();
      this.decorateGiftLines(cart);
      this.updateHeaderCount(cart);
      this.positionScroller(states);

      // Brinde recém-desbloqueado: desliza o scroller para o card novo
      // ficar na primeira posição à esquerda. SÓ rolagem — a seleção
      // (chosenTier) fica intocada. Os tiers desbloqueiam em ordem de
      // threshold (prefixo), então o primeiro idx novo == count anterior.
      // No primeiro render só registra o count (posição inicial é do
      // positionScroller).
      if (this._prevUnlockedCount != null && unlockedCount > this._prevUnlockedCount) {
        this.scrollToCard(this._prevUnlockedCount);
      } else if (this._prevUnlockedCount > 0 && unlockedCount === 0) {
        // Carrinho esvaziou a ponto de re-bloquear todos os brindes:
        // rolagem volta à posição inicial (primeiro card à esquerda).
        this.scrollToCard(0);
      }
      this._prevUnlockedCount = unlockedCount;
    }

    cardHtml(s, isNext) {
      var self = this;
      var tier = s.tier;
      var idx = s.idx;
      var img = (tier.products[0] && tier.products[0].image) || '';
      var totalPrice = tier.products.reduce(function (t, p) { return t + (p.price || 0); }, 0);

      var sub;
      if (s.unlocked) {
        sub = '<span class="cart-gifts__card-price"><s>' + money(totalPrice) + '</s> <em>Grátis</em></span>';
      } else {
        sub = '<span class="cart-gifts__card-sub">A partir de <strong>' + money(tier.threshold) + '</strong></span>';
      }

      var sizeUI = '';
      if (s.unlocked) {
        tier.products.forEach(function (p) {
          if (!p.needsSize) return;
          var key = idx + ':' + p.handle;
          var opts = (p.variants || []).map(function (v) {
            var dis = v.available ? '' : ' disabled';
            var sel = self.sizeChoice[key] === v.id ? ' selected' : '';
            return '<option value="' + v.id + '"' + dis + sel + '>' + esc(v.title) + '</option>';
          }).join('');
          var lbl = tier.products.length > 1 ? 'Tam. (' + esc(p.title.split(' ')[0]) + ')' : 'Tamanho';
          sizeUI += '<select class="cart-gifts__size" data-size-key="' + key + '"><option value="">' + lbl + '</option>' + opts + '</select>';
        });
      }

      var cls = 'cart-gifts__card' +
        (s.unlocked ? ' is-unlocked' : ' is-locked') +
        (isNext ? ' is-next' : '') +
        (s.selected ? ' is-selected' : '');

      return '<div class="' + cls + '" data-card="' + idx + '">' +
        '<span class="cart-gifts__card-imgwrap">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
          '<span class="cart-gifts__card-check">' + ICON_CHECK + '</span>' +
        '</span>' +
        '<div class="cart-gifts__card-info">' +
          '<span class="cart-gifts__card-name">' + esc(tier.label) + '</span>' +
          sub + sizeUI +
        '</div>' +
        (s.unlocked ? '<span class="cart-gifts__hand">' + ICON_HAND + '</span>' : '') +
      '</div>';
    }

    // Desliza o trilho até o card ficar na primeira posição à esquerda.
    // O alvo fica registrado em _scrollTarget para o próximo render
    // finalizar a posição mesmo que a animação seja interrompida.
    scrollToCard(idx) {
      var row = this.root.querySelector('.cart-gifts__scroller');
      var card = row && row.querySelector('[data-card="' + idx + '"]');
      if (!row || !card) return;
      var target = Math.max(0, Math.min(card.offsetLeft, row.scrollWidth - row.clientWidth));
      this._scrollTarget = target;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { row.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' }); }
      catch (e) { row.scrollLeft = target; }
    }

    // Posicionamento do scroller (régua + cards juntos): SÓ no primeiro
    // render (no selecionado ou no próximo da fila). Depois disso a
    // navegação fica com o cliente — sem rolagem automática.
    positionScroller(states) {
      if (this._cardsPositioned) return;
      var row = this.root.querySelector('.cart-gifts__scroller');
      if (!row) return;
      this._cardsPositioned = true;
      var targetIdx = this.chosenTier;
      if (targetIdx == null) {
        var next = states.find(function (s) { return !s.unlocked; });
        if (next) targetIdx = next.idx;
      }
      if (targetIdx == null) return;
      var card = row.querySelector('[data-card="' + targetIdx + '"]');
      if (!card) return;
      requestAnimationFrame(function () {
        row.scrollLeft = Math.max(0, Math.min(card.offsetLeft - 12, row.scrollWidth - row.clientWidth));
      });
    }

    bindEvents() {
      var self = this;
      this.root.querySelectorAll('[data-card]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          var idx = parseInt(el.getAttribute('data-card'), 10);
          var paid = self._lastCart ? self.eligibleTotal(self._lastCart) : 0;
          if (self.tierEligible(idx, paid)) {
            self.chooseGift(idx);
          } else {
            el.classList.add('cart-gifts__card--nudge');
            setTimeout(function () { el.classList.remove('cart-gifts__card--nudge'); }, 600);
          }
        });
      });
      this.root.querySelectorAll('[data-step]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          var idx = parseInt(el.getAttribute('data-step'), 10);
          var paid = self._lastCart ? self.eligibleTotal(self._lastCart) : 0;
          if (self.tierEligible(idx, paid)) {
            self.chooseGift(idx);
          } else {
            el.classList.add('cart-gifts__step--nudge');
            setTimeout(function () { el.classList.remove('cart-gifts__step--nudge'); }, 600);
          }
        });
      });
      this.root.querySelectorAll('.cart-gifts__size').forEach(function (s) {
        s.addEventListener('click', function (e) { e.stopPropagation(); });
        s.addEventListener('change', function (e) {
          e.stopPropagation();
          var key = s.getAttribute('data-size-key');
          if (s.value) self.sizeChoice[key] = parseInt(s.value, 10);
          else delete self.sizeChoice[key];
          var tierIdx = parseInt(key.split(':')[0], 10);
          if (self.chosenTier === tierIdx && s.value) self.swapSize(tierIdx);
        });
      });
    }

    flashSizePrompt(idx) {
      var card = this.root.querySelector('.cart-gifts__card[data-card="' + idx + '"]');
      var sel = card && card.querySelector('.cart-gifts__size');
      if (sel) {
        sel.classList.add('cart-gifts__size--alert');
        try { sel.focus(); } catch (e) { /* sem foco */ }
        setTimeout(function () { sel.classList.remove('cart-gifts__size--alert'); }, 1500);
      }
    }
  }

  if (!customElements.get('cart-gifts')) customElements.define('cart-gifts', CartGifts);
})();
